import { log } from "~features/seated-reservation/helpers/stateLogger";
import { showToast } from "~lib";
import { getState, setState } from "./../index";

interface ActionProps {
  isValid: boolean;
  violations: any; // From seating chart
}

export const chartToggleValidSelection = (payload: ActionProps) => {
  log("chartToggleValidSelection", payload);

  const state = getState();

  const validSeatSelection = payload.isValid;

  // For some reason this action is called twice from the
  // chart. This is to prevent double notifications.
  const changingToInvalid = state.validSeatSelection && !validSeatSelection;
  if (changingToInvalid && state.options.amount >= 0) {
    showToast(
      "Invalid seat selection. You have left a single seat empty",
      "error"
    );
  }

  return setState({ validSeatSelection });
};
